module.exports = __webpack_public_path__ + "cg.edbfbc876503c4c04833.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cg.svg
// module chunks = styles